import PaginationModel from "@/models/paginationModel";
import VendaModel from "@/models/vendaModel";
import { getCustomParams, getPaginationParams } from "@/utils/common/http";
import nfetch from "@/utils/events/nfetch";

import ManipulacaoOrdemItemModel from "../models/manipulacaoOrdemItemModel";

class PreVendaService {
    private controllerName = "PreVenda";

    public async listPreVendas(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        customProperties: { [key: string]: any } = {},
    ) {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, sortKey, sortOrder, pageIndex, pageSize);

        return await nfetch(`/${this.controllerName}/ListPreVendas?${pagination}` + custom, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<VendaModel>>();
    }

    public async checkPreVendaByProdutoId(produtoId: number) {
        return await nfetch(`/${this.controllerName}/CheckPreVendaByProdutoId?produtoId=${produtoId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<boolean>();
    }

    public async liberarVendasComLoteEmAnaliseByProdutoLoteId(produtoLoteId: number) {
        return await nfetch(
            `/${this.controllerName}/LiberarVendasComLoteEmAnaliseByProdutoLoteId?produtoLoteId=${produtoLoteId}`,
            {
                credentials: "same-origin",
            },
        )
            .withLoading()
            .resolveWithJSON<Array<VendaModel>>();
    }

    public async checkHasFaturamentoById(id: number) {
        return await nfetch(`/${this.controllerName}/CheckHasFaturamentoById?id=${id}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<boolean>();
    }

    public async checkEstoqueByLoteList(lotes: Array<ManipulacaoOrdemItemModel> = []) {
        return await nfetch(`/${this.controllerName}/CheckEstoqueByLoteList`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(lotes),
        })
            .withLoading()
            .resolveWithJSON<boolean>();
    }
}

export default new PreVendaService();
